export function uuid4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

const FIRST_DAY_OF_YEAR_MILLISECOND = new Date(
  new Date().getFullYear(),
  1,
  1
).getTime();

const ALPHABET = "abcdefghijklmnopqrstuwxyzABCDEFGHIJKLMNOPQRSTUWXYZ0123456789";

export function uniqid(size) {
  const prefix = Math.floor(
    (Date.now() - FIRST_DAY_OF_YEAR_MILLISECOND) * 0.001
  ).toString(36);

  return (
    prefix +
    String.fromCharCode.apply(
      null,
      crypto
        .getRandomValues(new Uint32Array(size - prefix.length))
        .map(x => ALPHABET.charCodeAt(x % ALPHABET.length))
    )
  );
}
